import { Link, useNavigate, useUrl } from "@shopify/hydrogen";
import { useEffect, useRef, useState } from "react";
import { SpinnerCircular } from "spinners-react";
import { useSearchStore } from "../../../store/modules/client";
import { debounce } from "lodash";
import { Formik, Field, Form } from "formik";

const NavSearch = ({ toggleSearch, searchNav, searchHandler }) => {
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [startSearching, setStartSearching] = useState(false);
  const [windowObj, setWindowObj] = useState(typeof window !== "undefined" && window)
  const navigate = useNavigate();
  const url = useUrl();
  const {searchParams, pathname} = url

  const { searchResults, fetchProducts } = useSearchStore();

  const search = debounce((term) => {
    searchParams.set("q", term)
    if (windowObj.history.replaceState) {
      const newURL = pathname + "?" + searchParams
      windowObj.history.replaceState({
        path: newURL
      }, "", newURL)
    }
    setLoading(true);
    setSearchValue(term);
    setStartSearching(true);
  }, 1000)

  const handleSubmit = async (payload) => {
    searchHandler();
    navigate(`/search?q=${payload.searched}`);
    searchNav.current.classList.toggle("hidden");
    document.body.classList.remove("overflow-hidden");
  };
  const fetchTheData = async () => {
    await fetchProducts(searchValue, {});
    setLoading(false);
  };

  useEffect(() => {
    if (!searchValue) return;
    fetchTheData();
  }, [searchValue]);

  return (
    <div
      ref={searchNav}
      className="w-full bg-white ml-auto text-black z-[70] hidden flex-col fixed top-[50px] md:top-[90px]"
    >
      <div
        onClick={(e) => toggleSearch(e)}
        className="h-[90px] bg-black opacity-0 w-full absolute inset-0 cursor-pointer top-[-90px]"
      ></div>
      <div
        onClick={(e) => toggleSearch(e)}
        className="absolute inset-0 w-full h-screen bg-black opacity-50 cursor-pointer"
      ></div>
      <div className="sticky top-0 bg-white z-[20]">
        <div
          className="bg-[#B8B8B859]"
          // onClick={() => inputRef.current?.focus()}
        >
          <Formik
            initialValues={{
              searched: "",
            }}
            onSubmit={handleSubmit}
          >
            <Form className="h-[80px] sm:mx-20 mx-2 flex md:justify-center justify-start items-center px-4">
              <div className="flex items-center justify-start w-full md:justify-center">
                <div className="flex w-full h-[50px]  border-b-[0.9px] border-[#808080] ">
                  <Field
                    placeholder="Please enter a keyword to start searching"
                    required
                    id="searchInput"
                    name="searched"
                    onKeyUp={(e) => {
                      search(e.target.value.toLowerCase());
                    }}
                    type="text"
                    className="w-full p-2 text-sm bg-transparent font-overpass-regular input-search placeholder:font-overpass-bold"
                  />
                </div>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
      <div className="flex items-center flex-col flex-grow w-full overflow-hidden relative max-h-[300px] h-fit navSearchWrapper pb-4">
        <ul className="w-10/12 mt-2 overflow-y-auto h-fit search-scroll">
          {loading && searchValue.length > 0 ? (
            <div className="flex items-center justify-center">
              <SpinnerCircular
                size={50}
                thickness={100}
                speed={100}
                color="rgba(220, 220, 220, 1)"
                secondaryColor="rgba(0, 0, 0, 0.5)"
                className="text-center"
              />
            </div>
          ) : startSearching && searchResults.length === 0 ? (
            <h3 className="">No Results Found</h3>
          ) : startSearching == true &&
            searchValue.length > 0 &&
            searchResults.length > 0 ? (
            <>
              <h3 className="mt-1 mx-auto pb-[10px]">Suggestions</h3>
              {searchResults.map((product, index) => (
                <li className="pb-[10px]" key={index}>
                  <Link
                    to={`/products/${product.handle}`}
                    onClick={(e) => {
                      toggleSearch(e);
                    }}
                  >
                    <div className="flex gap-[20px] w-full">
                      <div className="flex flex-col gap-[8px] w-full">
                        <div className="flex lg:flex-row flex-col lg:justify-between w-full gap-[10px]">
                          <p className="w-full text-sm tracking-[-0.71px]">
                            {product.title}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </li>
              ))}
            </>
          ) : (
            <div className="hidden"></div>
          )}
        </ul>
      </div>
    </div>
  );
};
export default NavSearch;
